// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CredentialDisableReasonSchema = z.enum(['MANUAL','AUTHENTICATION_FAILURE_THRESHOLD'] as const);

export type CredentialDisableReasonType = `${z.infer<typeof CredentialDisableReasonSchema>}`

export default CredentialDisableReasonSchema;
